import React from 'react'
import './productSearch.css'
import { getProductImageUrl } from 'Utils/getProductImageUrl'
import { Formatter } from 'Utils/Formatter'
import Loading from 'Components/Loading'
import { t } from 'i18next'

const ProductSearch = ({ listProducts, isLoading }) => {
  const channel = new BroadcastChannel('customer_display')

  return (
    <div
      className="container-product-search"
      id="container-product-search"
      data-testid="container-product-search">
      {listProducts?.length && (
        <h1 className="title-product-search" data-testid="title-product-search">
          {t('CUSTOMER_DISPLAY.TITLE_PRODUCT_SEARCH', {
            quantity: listProducts?.length,
          })}
        </h1>
      )}

      <div
        className="continer-product-card-product-search"
        data-testid="container-product-cards">
        {isLoading && (
          <div className="loading-overlay">
            <Loading full />
          </div>
        )}
        {listProducts?.length &&
          listProducts.map(product => (
            <>
              <div className="product-card-wrapper-product-search">
                <div className="product-card-search">
                  <div>
                    <div className="product-card-image-product-search">
                      <img
                        src={getProductImageUrl(product)}
                        onClick={() => {
                          channel.postMessage({
                            isProductDetail: true,
                            isLoadingProductDetail: true,
                            isSearchProducts: false,
                            productDetail: product,
                          })
                        }}
                        alt={product.ProductName}
                        className="img-fluid"
                      />
                    </div>
                    <div className="product-card-generals-product-search">
                      <h2 className="product-card-generals-title-product-search">
                        {product.ProductName}
                      </h2>
                      <p className="product-card-brand-product-search">
                        {product.Brand}
                      </p>
                      <p className="product-card-sku-product-search">
                        {product.Sku}
                      </p>
                      <div className="product-card-price-product-search">
                        <p>
                          {product.FinalPrice === undefined
                            ? 'Sin precio'
                            : '$' + Formatter.Money(product.FinalPrice)}
                        </p>
                        <div
                          className="product-promo"
                          style={{
                            display: product.Promo ? 'block' : 'none',
                          }}>
                          <p>{product.Promo || 'No Promo'}</p>
                        </div>
                        {product.BasePrice - product.FinalPrice > 0 && (
                          <div className="product-promo">Oferta</div>
                        )}
                        {product.FinalPrice < product.BasePrice && (
                          <p
                            style={{
                              textDecoration: 'line-through',
                              color: 'gray',
                            }}>
                            {`$${Formatter.Money(product.BasePrice)}`}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="product-card-buttons-product-search">
                    <button
                      onClick={async () => {
                        channel.postMessage({
                          isAddedProduct: true,
                          productCart: product,
                        })
                      }}>
                      Agregar
                    </button>
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </div>
  )
}

export default ProductSearch
